<template>
  <div
    :class="{
      'flex gap-2 items-center min-w-fit text-on-tertiary-container text-chips px-4 rounded-full transition-all duration-200 hover:transition-all hover:duration-200': true,
      'py-2 text-base': size == 'normal',
      'py-1 text-sm': size == 'small',
      'bg-inverse-on-surface': configuration == 'filled',
      'border bg-surface border-tertiary/16 hover:bg-tertiary-container/16':
        configuration == 'outlined',
      'flex-row-reverse': iconDirection == 'right',
    }"
  >
    <div v-if="icon" @click="$emit('click-icon')">
      <Icon
        :name="icon"
        :class="{
          'fill-on-tertiary-container': true,
          'max-h-6 max-w-6 w-6 h-6': size == 'normal',
          'max-h-[18px] max-w-[18px] w-[18px] h-[18px]': size == 'small',
          'cursor-pointer': iconIsAction,
        }"
      />
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Icon from '@/Components/Icon'
export default {
  name: 'ChipListItem',
  components: { Icon },
  props: {
    iconIsAction: { type: Boolean, required: false, default: false },
    configuration: {
      type: String,
      required: false,
      default: 'default',
      validator: value => ['default', 'filled', 'outlined', 'elevated'].includes(value),
    },
    icon: {
      type: String,
      required: false,
    },
    iconDirection: {
      type: String,
      required: false,
      default: 'left',
      validator: value => ['left', 'right'].includes(value),
    },
    size: {
      type: String,
      required: false,
      default: 'normal',
      validator: value => ['normal', 'small'].includes(value),
    },
  },
}
</script>

<style></style>
